import { Ref } from 'vue'

import { SwappableIncidentsConfigurationMap } from '@collector/sportsapi-client-legacy'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEventId } from '@desktop/views/Relation/composables/useEventId'
import {
  queryOptions,
  useQuery,
  type UndefinedInitialQueryOptionsWithDataTag,
  type UseQueryReturnType,
} from '@tanstack/vue-query'

type SwappableIncidentsQueryKey = readonly [
  'event',
  'swappableIncidents',
  Ref<number>,
]

type SwappableIncidentsQueryOptions = UndefinedInitialQueryOptionsWithDataTag<
  SwappableIncidentsConfigurationMap,
  Error,
  SwappableIncidentsConfigurationMap,
  SwappableIncidentsQueryKey
>

export function swappableIncidentsQueryOptions(
  eventId: Ref<number>,
): SwappableIncidentsQueryOptions {
  return queryOptions({
    queryKey: ['event', 'swappableIncidents', eventId] as const,
    queryFn: async (): Promise<SwappableIncidentsConfigurationMap> => {
      const response = await sportsApiClient.Events.SwappableIncidents.get(
        eventId.value,
      )

      return response.api.data
    },
  })
}

export const useSwappableIncidentsQuery = (
  options?: Omit<SwappableIncidentsQueryOptions, 'queryKey' | 'queryFn'>,
): UseQueryReturnType<SwappableIncidentsConfigurationMap, Error> => {
  const eventId = useEventId()
  return useQuery<
    SwappableIncidentsConfigurationMap,
    Error,
    SwappableIncidentsConfigurationMap,
    SwappableIncidentsQueryKey
  >({
    ...swappableIncidentsQueryOptions(eventId),
    ...options,
  })
}
